// @flow
import React, { Component } from 'react';
import { Field } from 'redux-form';
import { VoidChequeDiv } from './BankAccountStyles';
import FileUpload from '../../../components/FileUpload';
import { requiredField } from '../../../utilities/validations';

type Props = {
  fileUploadDirty: boolean,
  setFileUploadDirty: boolean => void
};

export default class VoidCheque extends Component<Props> {
  render() {
    return (
      <VoidChequeDiv>
        <h5>VOIDED CHEQUE OR BANK CONFIRMATION</h5>
        <Field
          name="voided_cheque"
          // hasPreview
          isDragActive
          // hasIcon
          // destroyCallback={this.props.deleteLogo}
          // currentUpload={this.props.voidedCheque}
          component={FileUpload}
          acceptedFileTypes=".jpg, .jpeg, .png, .gif, .pdf"
          maxSize={5000000}
          validate={requiredField}
          setFileUploadDirty={this.props.setFileUploadDirty}
          fileUploadDirty={this.props.fileUploadDirty}
        />
      </VoidChequeDiv>
    );
  }
}
